<template>
  <div class="homepage">
    <b-alert variant="danger" show v-if="typeof(violations) != 'string' && violations.length !== 0">
      <p class="text-center" v-for="(violation) in violations">{{ violation }}</p>
    </b-alert>
    <b-row class="section mt-0 mb-0">
      <b-row class="section-title mr-0 ml-0 pb-3 pt-2">
        <b-container class="pt-1 pb-1">
          <h1>How It Works</h1>
          <div class="explore-all-link">
            <b-link :to="{ name: 'Newsletter' }" class="btn btn-tertiary" id="SignUpForNewsletterButton"
                    title="Sign Up For Our Newsletter"
                    alt="Sign Up For Our Newsletter">
          <span class="d-none d-lg-inline">
            <strong>Sign up for our Newsletter</strong> &nbsp;
          </span>
              <i class="fas fa-arrow-alt-circle-right"></i>
            </b-link>
          </div>
        </b-container>
      </b-row>
      <b-row class="section-content mx-auto pb-4">
        <b-col class="text-center">
          <b-img src="/assets/images/HowItWorks.png" :fluid="true" alt="How It Works" title="How It Works"/>
        </b-col>
      </b-row>
    </b-row>

    <!-- Featured Projects row -->
    <b-row class="section bg-gray pb-4 featured-project">
      <b-container class="pt-1 pb-1">
        <h1 style="color: #fff;">Featured Projects</h1>
        <div class="explore-all-link">
          <b-link :to="{ name: 'ProjectList' }" class="btn btn-primary" id="AddProjectButton"
                  title="Explore All Projects"
                  alt="Explore All Projects">
          <span class="d-none d-lg-inline">
            <strong>Explore All Projects</strong> &nbsp;
          </span>
            <i class="fas fa-arrow-alt-circle-right"></i>
          </b-link>
        </div>
        <b-row>
          <b-col v-if="featuredProjects">
            <PhotoProjectCard :projects="{ ...featuredProjects.slice(0, 3) }"></PhotoProjectCard>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <!-- Stats row -->
    <b-row class="section statistics text-center pt-3 pb-4">
      <b-col>
        <b-row>
          <h1 class="mx-auto mb-1">
            We power participatory <br/>
            science projects all over the world
          </h1>
        </b-row>
        <div class="d-none d-lg-block">
          <b-row class="section-content my-4">
            <b-col>
              <div class="circle-icon stats elipsoidal text-center">
                <VueLoader v-if="isLoadingStats"/>
                <div class="inner-circle">
                  <b-row class="d-inline-block circle-text-content" v-if="!isLoadingStats">
                    <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.usersTotal) }}</p>
                    <div style="margin-top:-8px;">
                      <p class="mx-0 my-0 stat-name"> people</p>
                    </div>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="circle-icon stats elipsoidal text-center">
                <VueLoader v-if="isLoadingStats"/>
                <div class="inner-circle">
                  <b-row class="d-inline-block circle-text-content" v-if="!isLoadingStats">
                    <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.projectsTotal) }}</p>
                    <div style="margin-top:-8px;">
                      <p class="mx-0 my-0 stat-name"> projects</p>
                    </div>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="circle-icon stats elipsoidal text-center">
                <VueLoader v-if="isLoadingStats"/>
                <div class="inner-circle">
                  <b-row class="d-inline-block circle-text-content" v-if="!isLoadingStats">
                    <!-- <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.observationsTotal) }}</p> -->
                    <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.measurementsTotal) }}</p>
                    <div style="margin-top:-8px;">
                      <p class="mx-0 my-0 stat-name"> measurements</p>
                    </div>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="circle-icon stats elipsoidal text-center">
                <VueLoader v-if="isLoadingStats"/>
                <div class="inner-circle">
                  <b-row class="d-inline-block circle-text-content" v-if="!isLoadingStats">
                    <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.locationsTotal) }}</p>
                    <div style="margin-top:-8px;">
                      <p class="mx-0 my-0 stat-name"> locations</p>
                    </div>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="circle-icon stats elipsoidal text-center">
                <VueLoader v-if="isLoadingStats"/>
                <div class="inner-circle">
                  <b-row class="d-inline-block circle-text-content" v-if="!isLoadingStats">
                    <p class="mx-0 my-0 stat-number">{{ addThousandsPoint(stats.observationsTotal) }}</p>
                    <div style="margin-top:-8px;">
                      <p class="mx-0 my-0 stat-name"> observations</p>
                    </div>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!-- Photo Observations row -->
    <b-container class="pt-1 pb-1" style="">
      <h1>Recent Photo Observations</h1>
      <VueLoader v-if="isLoadingObservations"/>
      <div class="explore-all-data-link" style="margin-top: -62px; float:right;">
        <b-link :to="{ name: 'ObservationList' }" class="btn btn-tertiary" id="AddProjectButton"
                title="Explore All Data"
                alt="Explore All Data">
        <span class="d-none d-lg-inline">
          <strong>Explore All Data</strong> &nbsp;
        </span>
          <i class="fas fa-arrow-alt-circle-right"></i>
        </b-link>
      </div>
      <b-row class="section observations pb-4" v-if="!isLoadingObservations">
        <b-row class="section-content">
          <PhotoObservationCard v-for="(observation, index) in observationCards" :key="index" :isProjectPage=false
                                :observation=observation></PhotoObservationCard>
        </b-row>
      </b-row>
    </b-container>

    <!-- Mobile app row -->
    <b-row class="section bg-blue pb-4">
      <b-row class="section-title">
        <h1>Do Your Science Anywhere</h1>
      </b-row>
      <b-row class="section-content">
        <b-col cols="4" class="mt-5">
          <b-row class="mb-4 mt-5">
            <b-col center>
              <b-link href="https://apps.apple.com/us/app/citsci/id657196305" target="NewWindow"
                      alt="Get the app on the App Store" title="Get the app on the App Store">
                <b-img src="/assets/images/apple_app_store.png" fluid alt="Download on the App Store"
                       class="btn-download-app" center/>
              </b-link>
            </b-col>
          </b-row>
          <b-row class="ml-2 d-none d-md-block">
            <p class="text-white">The CitSci mobile app lets you quickly join
              projects, access projects and datasheets, and collect data on your smartphone.
              <router-link class="appLink" :to="{ name: 'Apps' }" alt="Learn more about our apps"
                           title="Learn more about our apps">
                Learn more
              </router-link>
            </p>
          </b-row>
        </b-col>
        <b-col cols="4">
          <router-link :to="{ name: 'Apps' }" alt="Learn more about our apps" title="Learn more about our apps">
            <b-img src="/assets/images/phonetemplate-citsci.png" fluid width="300"/>
          </router-link>
        </b-col>
        <b-col cols="4" class="mt-5">
          <b-col center class="ml-5">
            <b-row class="mb-4 mt-5">
              <b-link href="https://play.google.com/store/apps/details?id=com.nrel.citsci&hl=en_US&gl=US"
                      target="NewWindow" alt="Get the app on Google Play" title="Get the app on Google Play">
                <b-img src="/assets/images/google_app_store.png" fluid width="140"
                       alt="Download on the Google Play Store"
                       class="btn-download-app" center/>
              </b-link>
            </b-row>
          </b-col>
          <b-row class="mr-2 d-none d-md-block">
            <p class="text-white">Our apps let you save observations offline. Simply
              select a project and datasheet, enter data, and submit your saved observations later.
              <router-link class="appLink" :to="{ name: 'Apps' }" alt="Learn more about our apps"
                           title="Learn more about our apps">
                Learn more
              </router-link>
            </p>
          </b-row>
        </b-col>
      </b-row>
    </b-row>

    <!-- Testimonial row -->
    <b-row class="section testimonials pb-0 mb-0">
      <b-row class="section-title my-4">
        <h1>What People Are Saying</h1>
      </b-row>
      <b-row class="section-content mb-4">
        <b-card-group>
          <b-card tag="article" class="my-1 mx-4 text-center pb-3"
                  v-for="(testimonialsCard) in testimonialsCards" :key="testimonialsCard.id">

            <b-row class="mx-0 green-band">
              <b-row class="ml-3 font-weight-bold name-holder">{{ testimonialsCard.author.firstName }}
                {{ testimonialsCard.author.lastName }}
              </b-row>
              <b-row class="avatar-holder ml-0 mr-1">
                <b-img :src="testimonialsCard.author.photo" class="avatar"/>
              </b-row>
            </b-row>

            <b-card-text class="text-left">
              <div class="float-left"
                   style="color: #000; position: absolute; top:34px; left: 10px; font-size: 60px; font-family: Georgia, serif; font-weight: bold;">
                &#8220;
              </div>
              <p class="testimonialText">{{ testimonialsCard.text }}</p>
            </b-card-text>

            <b-row class="text-right mx-3 mt-2 testimonial-author float-right">
              {{ testimonialsCard.location }}
            </b-row>

          </b-card>
        </b-card-group>
      </b-row>
    </b-row>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {BTooltip} from 'bootstrap-vue';
import VueLoader from '../layout/Loader'
import ProjectJoinButton from "../../assets/scripts/project/projectJoinButton.vue";
import PhotoObservationCard from "../layout/PhotoObservationCard"
import PhotoProjectCard from "../layout/PhotoProjectCard";

export default {

  components: {
    BTooltip,
    VueLoader,
    ProjectJoinButton,
    PhotoObservationCard,
    PhotoProjectCard,
  },

  provide() {
    return {parentValidator: this.$validator}
  },

  data() {
    return {
      headerData: {
        backgroundPath: '/assets/images/header/Home_Image_1.jpg',
        picturePath: '',
        headerTitle: 'Your free participatory science platform',
        subHeaderTitle: 'Create projects, build datasheets, add data and view results in real-time',
        showHomepageButtons: true,
      },

      observationCardArr: [],

      testimonialsCards: [
        {
          id: 1,
          author: {
            firstName: 'Kate',
            lastName: 'Rinder',
            photo: '/assets/images/testimonials/KateRinder.png'
          },
          location: 'Youth Leadership Coordinator - North Cascades Institute',
          text: "I've looked at a number of different platforms and none of them have had the right tools and capacity for what we want to do. I'm excited that CitSci does!"
        },
        {
          id: 2,
          author: {
            firstName: 'Jorge',
            lastName: 'Figueroa',
            photo: '/assets/images/testimonials/JorgeFigueroa.png'
          },
          location: 'Principal and Director - El Laboratorio, Boulder CO',
          text: "CitSci is best-in-class. A powerful online platform for communities and community scientists to elegantly collect, manage, and analyze data with scientific integrity."
        },
        {
          id: 3,
          author: {
            firstName: 'Hope',
            lastName: 'Braithwaite',
            photo: '/assets/images/testimonials/HopeBraithwaite.png'
          },
          location: 'Water Quality Program Coordinator - Utah Water Watch',
          text: "I'm not sure what I would do without CitSci. They make coordinating projects a breeze. I can manage my sites and assign volunteers all in the same place."
        }
      ],
      baseURL: "",
    }

  },

  created() {
    this.reset()
    this.sendDataToHeader(this.headerData, this)
    this.$emit('is-homepage', true)
    //baseURL
  },

  mounted() {

    // Top 3 featured projects are fetched
    if (!this.projects || this.projects.length === 0) {
      // gets ALL featured projects
      this.getFeaturedProjects()
    }

    // Fetch the 4 most recent observations with images
    this.observationCardArr = []
    this.getAllObservationsList({urlParams: '?order[observedAt]=desc&exists[featuredPhoto]&itemsPerPage=4'})
    this.getStats()
  },

  computed: {
    ...mapGetters({
      error: 'project/show/error',
      violations: 'project/show/violations',
      isLoadingStats: 'about/show/isLoading',
      stats: 'about/show/stats',
      observationCards: 'observation/list/allItems',
      isLoadingObservations: 'observation/list/isLoadingAll',
      featuredProjects: 'project/list/featuredProjects',
      isLoadingProjects: 'project/list/isLoading',
    }),

  },

  methods: {
    ...mapActions({
      getStats: 'about/show/getStats',
      reset: 'about/show/reset',
      getFeaturedProjects: 'project/list/getFeaturedProjects',
      getAllObservationsList: 'observation/list/getAllObservationsList',
      joinToProject: 'project/show/joinToProject',
    }),

    addThousandsPoint(number) {
      // Fixes browser debugger error when number is undefined
      if (number == null)
        number = 0;

      number = number.toString()
      while (true) {
        var n2 = number.replace(/(\d)(\d{3})($|,|\.)/g, '$1,$2$3')
        if (number === n2) break
        number = n2
      }
      return number
    },

    onCardClick(evt, projectData) {
      evt.preventDefault();

      if (evt.target.getAttribute('class').indexOf('btn-join') !== -1) {
        if (JSON.parse(localStorage.getItem('sessionData')) == null) {
          this.$root.$emit('bv::show::modal', 'not-logged-in-modal');
          return;
        } else {
          this.joinToProject({id: projectData.id});
          return;
        }
      }

      this.$router.push('/projects/' + projectData.urlField);
    },

    mouseOver() {
      // this.$refs.buttonTooltip1.$emit('open')
    }
  },

  watch: {
    violations(newViolationsVal) {
      if (typeof newViolationsVal == 'object' && newViolationsVal != null && newViolationsVal._error.length > 0) {
        delete newViolationsVal._error
      }
      return newViolationsVal
    },
  },

  beforeDestroy() {
    this.reset()
  }
}

</script>

<style lang="scss" scoped>
/*
Extra small devices (portrait phones, less than 544px)
No media query since this is the default in Bootstrap because it is "mobile first"
*/
h1 {
  font-size: 2rem;
}

/*was 1 rem; 1rem = 16px*/
/*
####################################################
M E D I A  Q U E R I E S
####################################################
*/

/*
::::::::::::::::::::::::::::::::::::::::::::::::::::
Bootstrap 4 breakpoints
*/
/* Small devices (landscape phones, 544px and up) */
@media (min-width: 544px) {
  h1 {
    font-size: 2.5rem;
  }
  /*was 1.5rem; 1rem = 16px*/
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }
  /*was 2rem; 1rem = 16px*/
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  h1 {
    font-size: 3rem;
  }
  /*was 2.5rem; 1rem = 16px*/
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  h1 {
    font-size: 3rem;
  }
  /*was 3rem; 1rem = 16px*/
}

/*
::::::::::::::::::::::::::::::::::::::::::::::::::::
Custom media queries
*/

/* Set width to make card deck cards 100% width color:red; */
@media (min-width: 950px) and (max-width: 1100px) {
  h1 {
    font-size: 2.75rem;
  }
}

/* ---------------------------------------------
:::::::::::::::::: other css ::::::::::::::::::
 --------------------------------------------- */

.appLink {
  color: #000000;
}

.appLink:hover {
  text-decoration: underline;
}


.card {
  width: 245px;
}

.testimonialText {
  text-indent: 40px;
  margin-top: 16px;

  // Extra small devices (portrait phones, less than 576px)
  // No media query for `xs` since this is the default in Bootstrap
  font-size: 1rem;
  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {
    font-size: 1rem;
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    font-size: 1rem;
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    font-size: 1.4rem;
  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
    font-size: 1.4rem;
  }
}

.section-title {
  width: 100%;
  justify-content: center;
}

.section-content {
  width: 100%;
  max-width: 1100px;
  justify-content: center;
  margin: auto;

  &.how-it-works {
    max-width: 613px;
  }

  .circle-icon {
    width: 152px;
    height: 126px;
    padding: 33px 33px;

    &.lightbulb {
      border-color: #93A05A;
      padding-left: 37px;
      width: 100px;
      height: 100px;
    }

    &.chart {
      border-color: #93A05A;
      padding-left: 37px;
      width: 100px;
      height: 100px;
    }

    &.edit {
      width: 100px;
      height: 100px;
    }

    &.stats.elipsoidal {
      background: #fff;
      color: grey;
      border-color: grey;
      width: 152px;
      height: 126px;
      padding: 30px 0 0 0;
      cursor: pointer;

      &:before {
        position: absolute;
        z-index: -1;
        display: block;
        content: '';
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transition: all .5s;
        transition: all .5s;
      }

      &:after {
        top: 40px;
        left: 84px;
        width: 50px;
        height: 42.5px;
        border-radius: 50%;
        -webkit-transform: scale(.5);
        transform: scale(.5);
        cursor: pointer;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transition: all .5s;
        transition: all .5s;
        position: absolute;
        z-index: -1;
        display: block;
        content: '';
      }

      &:hover:after {
        top: 0;
        left: 34px;
        width: 152px;
        height: 126px;
        background: #00B0F0;
        border-radius: 50%;
        -webkit-transform: scale(.9);
        transform: scale(.9);
        cursor: pointer;
        z-index: 0;
      }

      .inner-circle {
        height: 100%;
        border-radius: 50%;

        .circle-text-content {
          width: 100%;
          height: 100%;
          margin: -24px 0 30px 0;
          padding-top: 20px;
          border-radius: 50%;
        }

        .stat-number {
          font-size: 30px;
        }

        .stat-name {
          font-size: 16px;
          margin-top: -6px;
        }

        &:hover {
          z-index: 10;
          color: #fff;
          position: relative;

          .stat-number {
            color: #fff;
          }

          .stat-name {
            color: #fff;
          }
        }
      }

    }
  }

  .line {
    border: 2px solid #87983f;
    height: 2px;
    margin-top: 46px;
    margin-left: -52px;
    margin-right: -52px;

    @media screen and (max-width: 550px) {
      margin-left: -33px;
      margin-right: -32px;
    }
  }

  .how-it-works-text {
    font-size: 18px;
    font-family: Helvetica, Arial, sans-serif;
    width: 200px;
    justify-content: center;

    @media screen and (max-width: 550px) {
      margin-top: 1rem !important;
      margin-bottom: 1rem !important;
      width: 160px;
      text-align: center;
    }
  }
}

.section {
  width: 100%;

  &.featured-project {
    @media screen and (max-width: 1050px) {
      padding-right: 4rem !important;
      padding-left: 4rem !important;
    }
  }

  &.observations {
    @media screen and (max-width: 1050px) {
      padding-right: 4rem !important;
      padding-left: 4rem !important;
    }

    .card-body {
      justify-content: center;
      min-height: auto;
    }
  }

  &.bg-gray {
    background: #808080;

    & > .section-title {
      color: #fff;
    }
  }

  .explore-all-link {
    //width:200px;
    text-decoration: none;
    position: relative;
    float: right;
    margin-top: -62px;
    margin-right: 0px;
    max-height: 38px;
  }

  .explore-all-data-link {
    /*color: #fff;*/
    text-decoration: none;
    position: relative;
    float: right;
    margin-top: -62px;
    margin-right: 0px;
    max-height: 38px;
    //border: solid 1px red;
  }

  .color-white:hover {
    color: #03a9f4;
  }

  .card-holder {
    justify-content: center;
  }

  .card-image-container {
    min-height: 150px;
    max-height: 150px;
  }

  .card-body {
    max-width: 243px;
    max-height: 300px;
    min-height: 300px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;

    .card-title {
      display: none;
    }

    .card-content, .card-btn {
      flex-direction: column;
      overflow: hidden;
    }

    .card-img-top {
      padding-bottom: 6px;
    }

    .btn-transparent {
      color: #FFFFFF; /* #00b0f0 */
      background-color: #87983F !important; //87983F

      &:hover {
        background-color: #03a9f4 !important;
        border-color: #03a9f4 !important;
        color: #fff;
      }
    }

    .btn-transparent a {
      color: #FFFFFF;
    }

    .btn-light-blue {
      background-color: #03a9f4;
      border-color: #03a9f4;
    }

    .btn-light-blue:hover {
      background-color: #87983F !important;
      border-color: #87983F !important;
    }

    .create-project-plus {
      font-size: 60px;
      color: #03a9f4;

      a {
        color: #03a9f4;
      }
    }

    .project-description {
      color: #8F9AA4;
      font-size: 11px;
      margin-top: -10px;
    }

    .membership {
      max-width: 39px;
      max-height: 39px;
      margin-top: -50px;
      align-self: flex-end;
      margin-right: 10px;

      img {
        max-width: 39px;
        max-height: 39px;
      }
    }

    .members-date {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      margin-bottom: 0px !important;
    }

    .members {
      font-weight: bold;
    }

    .green-band {
      background: #A3B266;
      padding: 0;
      margin-top: -6px;
      max-height: 27px;
      color: #fff;
      justify-content: space-between;

      & .name-holder {
        margin-top: 2px;
      }

      & > .avatar-holder {
        text-align: right;
        margin-top: -15px;
        display: inline;
        // Small devices (landscape phones, 576px and up)
        @media (min-width: 576px) {
          display: none;
        }

        // Medium devices (tablets, 768px and up)
        @media (min-width: 768px) {
          display: inline;
        }

        // Large devices (desktops, 992px and up)
        @media (min-width: 992px) {
          display: inline;
        }

        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 1200px) {
          display: inline;
        }
      }

      h5 {
        font-size: 1.1rem;
      }
    }

    .details {
      color: #AAAAAA;
    }
  }

  &.statistics {
    background-image: url('../../assets/images/homepage/GlobalMapBackground.png');
    background-repeat: repeat-x;
  }

  &.bg-blue {
    background: #00B0F0;

    & > .section-title {
      color: #fff;
    }

    & > .section-content {
      font-size: 14px;
    }

    .btn-download-app {
      max-width: 140px;
      max-height: 45px;
    }
  }

  &.testimonials {
    .card {
      border: 0;
    }

    .card-body {
      max-width: 320px;
      min-height: auto;

      .green-band {
        max-height: 48px;
        font-size: 16px;

        .name-holder {
          margin-top: 13px;
        }

        .avatar-holder {
          margin-top: -12px;

          .avatar {
            height: 72px;
            width: 72px;
          }
        }
      }

      .testimonial-author {
        color: #AAAAAA;
        align-self: flex-end;
      }

      .testimonial-body {
        text-indent: 30px;
        display: inline-block;

        & > span.quote {
          content: "\201C";
          font-family: Georgia, serif;
          font-size: 60px;
          font-weight: bold;
          /*position: absolute;*/
          position: relative;
          left: -20px;
          top: 0px;
        }

        & > .text {
          /*margin-top: -160px;*/
        }
      }
    }
  }

}

.homepage {
  & > .row {
    margin-left: 0;
    margin-right: 0;
  }
}

</style>
